import React, { memo, useState } from "react";
import { CardText, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { Toast } from "utility/helpers";
import PropTypes from "prop-types";
import { genericPost, genericPut } from "services/services.general";
import styled from "styled-components";
import { AddButton } from "assets/js/Styles";
import FormGenerator from "../form-generator/input";

import "react-bootstrap-tagsinput/dist/index.css";

const TextareaContainer = styled.div`
  margin-top: 1rem;
`;

const Container = styled.div`
  padding: 0;
  margin-bottom: 1rem;
`;

const StyledModal = styled(Modal)``;

const StyledCardText = styled(CardText)`
  text-align: center;
  margin-top: 1rem;
`;

const ModalBodyContainer = styled.div`
  margin-right: 0.5rem;
  margin-left: 0.5rem;
`;

const ButtonActionSection = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledSaveButton = styled(AddButton)`
  background: ${({ theme }) => theme.colors.buttonFormBlue};
  width: 100px;
  border: none;
  height: 45px;
`;

const DeclineModal = ({
  isOpen,
  event,
  handleClose,
  fetchComments,
  fetchDataTable,
  eventName,
  eventId,
  view,
}) => {
  const [reason, setReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    if (!reason.trim()) {
      return Toast({
        type: 4,
        content: "Reason cannot be empty.",
      });
    }

    const newStatus = "Declined";
    const data = event;

    data.eventParticipantStatus = newStatus;

    genericPost({
      url: "/comment",
      formData: {
        text: reason,
        recipientId: null,
        newsId: null,
        eventId,
      },
      callback: ({ isSuccess }) => {
        if (isSuccess) {
          setReason("");
          if (view === "rep") fetchComments(eventId);
          setIsLoading(false);
        }
      },
    });

    genericPut({
      url: `/eventsparticipant/${data.id}`,
      formData: {
        declineReason: reason,
        eventParticipantStatus: newStatus,
      },
      callback: ({ isSuccess }) => {
        if (isSuccess) {
          setReason("");
          fetchDataTable();
          setIsLoading(false);
        }
      },
    });

    return handleClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      toggle={handleClose}
      centered
    >
      <ModalHeader toggle={handleClose}>{"Decline Event"}</ModalHeader>
      <ModalBody>
        <ModalBodyContainer>
          <Container>
            <StyledCardText>
              {`Kindly indicate your reason to decline 
                  the invitation at ${eventName}`}
            </StyledCardText>

            <TextareaContainer>
              <FormGenerator
                type="textarea"
                rows={5}
                value={reason}
                disabled={isLoading}
                onChange={(e) => {
                  const { value } = e.target;

                  setReason(value);
                }}
                placeholder="Reason to decline"
              />
            </TextareaContainer>
          </Container>

          <ButtonActionSection>
            <StyledSaveButton
              onClick={() => handleSubmit()}
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  color="light"
                  size="sm"
                />
              ) : (
                "Submit"
              )}
            </StyledSaveButton>
          </ButtonActionSection>
        </ModalBodyContainer>
      </ModalBody>
    </StyledModal>
  );
};

DeclineModal.prototype = {
  isOpen: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.string]),
  handleClose: PropTypes.func,
  type: PropTypes.string,
  messageType: PropTypes.string,
};

export default memo(DeclineModal);
